import { LoadedUser } from '../../interfaces';
import { isSudoManager } from '../../utils/global/helper';

export const userHasAccessToCapital = (
  user:
    | Pick<LoadedUser, 'role' | 'canViewReports' | 'business'>
    | null
    | undefined,
) => {
  if (!user || !user.business) return false;
  return user.business.type === 'INDEPENDENT' || isSudoManager(user);
};
